import { createSxStyles } from "@common/createSxStyles";

export const useBulkMitigateDialogStyles = () =>
    createSxStyles({
        content: {
            display: "flex",
            flexDirection: "column",
            gap: 1,
        },
        subHeader: {
            display: "flex",
            justifyContent: "center",
        },
        entityTable: {
            maxHeight: 700,
            overflowY: "auto",
        },
    });
